import associations from '@associations/routes/Public';

import users from '@users/routes/Public';

import { IRoute } from '..';

export default [...associations, ...users] as IRoute[];
